import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
}));

const LoadingButton = ({
  text,
  style,
  loading,
  disabled,
  onClick,
  children,
  size,
  color,
  variant,
}) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.wrapper}>
        <Button
          disabled={disabled || loading}
          style={style}
          margin='normal'
          type='button'
          fullWidth
          variant={variant || 'contained'}
          color={color || 'primary'}
          size={size}
          // startIcon={<AddIcon />}
          onClick={onClick}
        >
          {text}
          {children}
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </>
  );
};

export default LoadingButton;
